import { isValidEmail } from '@/shared/utils/contato';
import { isCnpj, isValidCpfCnpj, normalizeCpfCnpj } from '@/shared/utils/documentValidation';

import type { PerfilSelf } from '../types';

const DOMINIO_COM_TLD = /\.[a-zA-Z]{2,}$/;

export function emailPerfilValido(email: string): boolean {
  const limpo = email.trim();
  return isValidEmail(limpo) && DOMINIO_COM_TLD.test(limpo);
}

export function cnpjPerfilValido(cnpj: string): boolean {
  const documento = normalizeCpfCnpj(cnpj);
  return isCnpj(documento) && isValidCpfCnpj(documento);
}

export function perfilProntoParaBusca(perfil: PerfilSelf): boolean {
  return (
    perfil.nome.trim().length > 0 &&
    emailPerfilValido(perfil.email) &&
    cnpjPerfilValido(perfil.cnpj) &&
    perfil.razaoSocial.trim().length > 0 &&
    perfil.nomeFantasia.trim().length > 0 &&
    perfil.site.trim().length > 0
  );
}
